import { Box, Center, Spinner } from '@agrotoken-tech/ui';
import { ContactForm } from './ContactForm';
import { useQuery } from '@tanstack/react-query';
import { getCompanyContactInfo } from '../../../services/company';

export const ContactInfoSection = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['contactInfo'],
    queryFn: getCompanyContactInfo,
  });

  if ((!data && isLoading) || !data)
    return (
      <Center>
        <Spinner />
      </Center>
    );

  return (
    <Box maxW="868px">
      <ContactForm data={data} />
    </Box>
  );
};
